import { Button, Stack } from '@mui/material'
import { UIShareLearnArticleImg } from 'features/UI'
import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import { ArticleType, ShareTimelineItem } from 'types'
import { getRoute } from 'utils'
import { TimelineItemCard } from '../../../Timeline/components/TimelineItemCard/TimelineItemCard'
import { TimelineLine } from '../../../Timeline/components/TimelineLine/TimelineLine'

export function SharedLearnArticleItem({
  item,
  commentControl,
}: {
  item: ShareTimelineItem
  commentControl?: ReactNode
}) {
  const navigate = useNavigate()

  const onClickArticle = () => {
    const route = getRoute(routes.sharedItem, {
      sharedItemType: ArticleType.LearnLibrary,
      sharedItemId: item.id,
    })
    navigate(route)
  }

  if (!item.learnArticle) {
    return null
  }

  return (
    <Stack direction="row" spacing={2}>
      <div style={{ position: 'relative', minWidth: 30, minHeight: '100%' }}>
        <UIShareLearnArticleImg isOnTimeline />
        <TimelineLine />
      </div>

      <TimelineItemCard
        title={item.learnArticle.post || item.learnArticle.name}
        bannerUrl={item.learnArticle.bannerUrl}
        status={item.status}
        readingTime={item.learnArticle.silentReadingTime}
        commentControl={commentControl}
        onClick={onClickArticle}
        controls={
          <Button size="small" variant="contained" onClick={onClickArticle}>
            View
          </Button>
        }
      />
    </Stack>
  )
}
